/* assets/briyo-prefetch.js - hover-intent page prefetch.
   When a mouse rests on an eligible internal link for PF_DELAY ms, the
   destination HTML is requested with <link rel="prefetch" as="document">.
   That only warms the HTTP cache: nothing is parsed or executed, so the
   destination's pixels/analytics fire only on the real navigation.
   Conservative allow-list; anything not clearly a plain storefront page
   is skipped. Touch/pen never trigger it. No-op where unsupported. */
(function () {
  var PF_DELAY = 65;
  var PF_MAX = 20;

  var probe = document.createElement('link');
  if (!probe.relList || !probe.relList.supports || !probe.relList.supports('prefetch')) return;
  var conn = navigator.connection;
  if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;

  var ALLOW = /^\/(?:$|products\/[^/]+\/?$|collections\/[^/]+(?:\/products\/[^/]+)?\/?$|pages\/[^/]+\/?$|blogs\/[^/]+(?:\/[^/]+)?\/?$)/;
  var done = {};
  var count = 0;
  var timer = null;
  var pendingLink = null;

  function eligible(a) {
    if (!a || !a.href) return null;
    if (a.hasAttribute('download')) return null;
    var t = a.getAttribute('target');
    if (t && t !== '_self') return null;
    if (a.closest('[data-no-prefetch]')) return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return null;
    if (u.search) return null;
    if (!ALLOW.test(u.pathname)) return null;
    if (u.pathname === location.pathname) return null;
    return u.origin + u.pathname;
  }

  function prefetch(url) {
    if (done[url] || count >= PF_MAX) return;
    done[url] = true;
    count++;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.as = 'document';
    l.href = url;
    document.head.appendChild(l);
  }

  function cancel() {
    if (timer) { clearTimeout(timer); timer = null; }
    pendingLink = null;
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a === pendingLink) return;
    cancel();
    var url = eligible(a);
    if (!url || done[url]) return;
    pendingLink = a;
    timer = setTimeout(function () { timer = null; pendingLink = null; prefetch(url); }, PF_DELAY);
  }, { passive: true });

  document.addEventListener('pointerout', function (e) {
    if (!pendingLink) return;
    if (e.relatedTarget && pendingLink.contains(e.relatedTarget)) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (a === pendingLink) cancel();
  }, { passive: true });
})();
